export default "assets/logo-6ce11693.png";